import { render, staticRenderFns } from "./GenAiDashboard.vue?vue&type=template&id=2f2e353a&scoped=true&"
import script from "./GenAiDashboard.vue?vue&type=script&lang=ts&"
export * from "./GenAiDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./GenAiDashboard.vue?vue&type=style&index=0&id=2f2e353a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e353a",
  null
  
)

export default component.exports